export const META_ATTACH_ADD = 'META_ATTACH_ADD';
export const META_ATTACH_CLEAR = 'META_ATTACH_CLEAR';
export const META_ATTACH_REQUEST = 'META_ATTACH_REQUEST';
export const META_ATTACH_SUCCESS = 'META_ATTACH_SUCCESS';
export const META_ATTACH_FAILURE = 'META_ATTACH_FAILURE';



// WEBPACK FOOTER //
// ./src/js/actions/metaAttachActionTypes.js